export default __webpack_public_path__ + "assets/latvia-flag.png";